<template>
  <div class="bom">
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <div v-if="isProductionPlan" class="data-area">
      <ul>
        <li class="text-title">生産計画リスト</li>
        <li>「生産計画リスト」左のチェックボックスをご選択いただき「チェックしたドキュメントの送信」をクリックください。<br>
          生産計画リストが添付されたメールが、登録メールアドレス宛に送られます。
        </li>
      </ul>
    </div>
    <div v-else-if="isManufactureDoc" class="data-area">
      <ul>
        <li class="text-title">製造指示</li>
        <li>「製造管理」左のチェックボックスをご選択いただき「チェックしたドキュメントの送信」をクリックください。<br>
          加工指示リスト/コンバイン明細リスト/梱包ラベルが添付されたメールが、登録メールアドレス宛に送られます。
        </li>
      </ul>
    </div>
    <div v-else-if="isMaterialList" class="data-area">
      <ul>
        <li class="text-title">資材所要量一覧</li>
        <li>「資材所要量一覧」左のチェックボックスをご選択いただき「チェックしたドキュメントの送信」をクリックください。<br>
          資材所要量一覧が添付されたメールが、登録メールアドレス宛に送られます。
        </li>
      </ul>
    </div>
    <div v-else-if="isPartsLabel" class="data-area">
      <ul>
        <li class="text-title">パーツラベル</li>
        <li>「パーツラベル」左のチェックボックスをご選択いただき「チェックしたドキュメントの送信」をクリックください。<br>
          パーツラベルが添付されたメールが、登録メールアドレス宛に送られます。
        </li>
      </ul>
    </div>
    <div v-else-if="isNcData" class="data-area">
      <ul>
        <li class="text-title">NC DATA</li>
        <li>「NC DATA」左のチェックボックスをご選択いただき「チェックしたドキュメントの送信」をクリックください。<br>
          NC DATAが添付されたメールが、登録メールアドレス宛に送られます。
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Modal from '../../components/common/Modal'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'BomPreview',
  components: {
    'dd-modal': Modal,
    'dd-loading-modal': LoadingModal
  },
  props: {
    isProductionPlan: Boolean,
    isManufactureDoc: Boolean,
    isMaterialList: Boolean,
    isPartsLabel: Boolean,
    isNcData: Boolean
  },
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
.bom {
  display: inline-block;
  width: 100%;
  height: 100%;
  overflow: auto;
}
table {
  width: auto;
  td {
    white-space: nowrap;
    border: 1px solid #ddd;
  }
}
.data-area {
  li {
    padding-top: 24px;
    padding-left: 12px;
    line-height: normal;
  }
  .text-title {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/sheet/Infomation.vue